export function checkLightUserRequestFlagExistence(
  LightUserRequest: string | undefined,
): {isValid: boolean} {
  if (typeof LightUserRequest !== 'string') return {isValid: false};
  return {isValid: Boolean(LightUserRequest)};
}
